module.exports = __webpack_public_path__ + "img/mew-icon.de3130df.png";